<template lang="pug">
div
  section.u-mt-lg
    AppTitle(:title="$t('discover')" tag="h1")
  .u-mb-mi

</template>

<script>
import { generateSeoMeta } from '~/utils/seo';

export default {
  scrollToTop: true,
  head: generateSeoMeta({ title: 'pageTitle', description: 'pageDesc' }, { i18n: true })
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Folklore",
    "pageDesc":"Illustrating characters and patterns to show you the cultural side of the civilization and inspire your heritage projects.",
    "discover": "Discover different |arts form all over| the world."
  },
  "ar": {
    "pageTitle":"فلكلور",
    "pageDesc":"نوضح الجوانب الثقافية والحضارية للبشرية من خلال رسم الشخصيات والأنماط. بداية من الثقافة الفرعونية إلى الأساطير اليونانية",
    "discover": "اكتشف مدارس |الفن المختلفة |حول العالم."
  }
}
</i18n>
